import React from "react"
import { Link } from 'react-router'

export default class Navigation extends React.Component {
  render() {
    return (
      <nav className={'page-container ' + this.props.content.headerStyle}>
        <ul className="navigation">
          { this.props.content.nav.links.map((link, i) => {
              return (
                <li key={i}>
                  <Link to={link.link} activeClassName="active">{link.text}</Link>
                </li>
              )
            }) }
        </ul>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global/Navigation.js